import { BrandListerGroupedFilterTypes } from './enums';

export type BrandListerState = {
  items?: Array<BrandListerItem>;
  filters?: Array<BrandListerFilterItem>;
  popularList?: {
    [brandId: string]: number;
  };
};

export type BrandListerItem = {
  language: string;
  id: string;
  fredhopperCode: string;
  active: boolean;
  visible: boolean;
  mainWebShop: string;
  description: string;
  relativePath: string;
  alias: string;
  popular: number;
  logo: string;
  logoTimestamp: number;
};

export type BrandListerFilterItem = {
  key: BrandListerGroupedFilterTypes | string;
  active: boolean;
};

export type BrandListerOptions = {
  skipBrands: Array<string>;
  view: string;
  timestamp: string;
};
